import { useTheme } from '@mui/material'

type IconType = {
  width?: number
  height?: number
  strokeWidth?: number
  open?: boolean
}

export const ExpandMenu = ({
  width = 32,
  height = 32,
  strokeWidth = 15,
  open = false
}: IconType) => {
  const { palette } = useTheme()

  const color = palette.common.white

  return (
    <svg
      id="expand-menu-id"
      data-name="expand-menu-icon"
      viewBox="0 0 234 167"
      width={width}
      height={height}
    >
      <line
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        x1="36"
        y1="32"
        x2="199.5"
        y2="32"
      />
      <line
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        x1="36"
        y1="135"
        x2="199.5"
        y2="135"
      />
      <g
        style={{
          transform: open ? 'scaleX(-1)' : 'scaleX(1)',
          transformOrigin: 'center',
          transition: 'all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms'
        }}
      >
        <line
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          x1="36"
          y1="83.5"
          x2="147.5"
          y2="83.5"
        />
        <path
          fill={color}
          d="M200.71,79.07c2.95,2.53,2.95,7.1,0,9.63l-11.47,9.84-10.87,9.32c-2.44,2.1-6.22,.36-6.22-2.86V62.77c0-3.22,3.78-4.95,6.22-2.86l10.87,9.32,11.47,9.84Z"
        />
      </g>
    </svg>
  )
}
